/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sa_Applies_To_FinalsInputs */



/**
* | output |
* | --- |
* | "Applies to the player's current/most-recent game: the finals" |
*
* @param {Sanction_Sa_Applies_To_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sa_applies_to_finals = /** @type {((inputs?: Sanction_Sa_Applies_To_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sa_Applies_To_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'applique à la partie en cours/la plus récente du joueur : la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se aplica a la partida actual/más reciente del jugador: las finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aplica-se à partida atual/mais recente do jogador: as finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si applica alla partita corrente/più recente del giocatore: le finali")
	return /** @type {LocalizedString} */ ("Applies to the player's current/most-recent game: the finals")
});